import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useEnableTsdSimulatorMode = () => {
  const queryClient = useQueryClient();

  return apiClient.customsSimulator.enableTsdCustomsSimulator.useMutation({
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      toast.success(data.body.message || 'Simulator mode enabled for this TSD');
    },
    onError: (error) => {
      showErrorToast(error, 'Error enabling TSD simulator mode');
    },
  });
};
